import { dbisHttp, wmsHttp, otmsHttp } from '@/utils/http/index.js'

/**
 * 根据货品id查询指定范围内批次
 * https://yapi.ops.yunlizhi.cn/project/507/interface/api/18133
 */
export function getGoodBatch(data) {
  return dbisHttp.post('/dashboard/wms/goods/batch', data)
}

/**
 * 根据批次查询运输状态
 * https://yapi.ops.yunlizhi.cn/project/507/interface/api/18139
 */
export function getBatchStatus(data) {
  return dbisHttp.post('/dashboard/wms/goods/batch/dispatch', data)
}

/**
 * 货主货品的查询
 * https://yapi.ops.yunlizhi.cn/project/388/interface/api/11442
 */
 export function getPageByShipper(data, params) {
  return wmsHttp.post('/warehouse_foundation/warehouse_goods/page', data, {
    params
  })
}
/**
 * 获取仓库列表
 *  https://yapi.ops.yunlizhi.cn/project/194/interface/api/18015
 */
 export function getWareHouse(data,params) {
  return otmsHttp.request({
      url: '/customer/ext/page',
      method: 'post',
      data,
      params
  })
}